// GEO_EXEC_R5 · the effect panel ("did the GEO site do anything").
//
// Every route here 404s while the switch is off, which is what `probeFeature` reads to decide
// whether the Impact entry exists at all. Nothing in this file interprets the payload: the one
// rule R5 is built around — a missing fact is never a zero — lives in the shape the server sends
// (a metric with no denominator has no `n` at all), and the view renders that shape verbatim.

import { api, apiPrefix } from "./client";

export function getGeoSiteEffect(brandId, { baselineRunId, runId, signal } = {}) {
  const query = new URLSearchParams();
  if (baselineRunId) query.set("baseline_run_id", String(baselineRunId));
  if (runId) query.set("run_id", String(runId));
  const suffix = query.toString() ? `?${query}` : "";
  return api(`/api/geo-exec/r5/brands/${encodeURIComponent(brandId)}/geo-site-effect${suffix}`, { signal });
}

export function listBaselineRuns(brandId, { signal } = {}) {
  return api(`/api/geo-exec/r5/brands/${encodeURIComponent(brandId)}/runs`, { signal });
}

export function setBaselineRun(brandId, runId, { signal } = {}) {
  return api(`/api/geo-exec/r5/brands/${encodeURIComponent(brandId)}/baseline`, {
    method: "PUT",
    json: { run_id: runId },
    signal,
  });
}

/** The per-question table as CSV. A link, not a fetch: the server sets the download filename. */
export function geoSiteEffectCsvUrl(brandId) {
  return `${apiPrefix()}/api/geo-exec/r5/brands/${encodeURIComponent(brandId)}/geo-site-effect?format=csv`;
}
